
const Countries = {
	Plural: 'Countries',
	Single: 'Country',
	DefaultSorting: 'Name',
	DefaultSortingType: 'desc',
	Columns: [
		{
			name: '',
			label: '#',
			type: 'counter',
		},
		{
			name: 'id',
			dbName: 'id',
			label: 'ID',
			sortable: true,
			required: true,
			type: 'text',
		},
		{
			name: 'name',
			dbName: 'Name',
			label: 'Name',
			sortable: true,
			required: true,
			type: 'text',
		}
		
		
	],
	
	PrimaryKey: 'id',
	Actions: {
		addLink: '/country/add/',
		editLink: '/country/edit/',
		deleteLink: true,
	},
};

export default Countries;
